export default "__VITE_ASSET__d99d07df__"